
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconTrashSelector = "fhi-icon-trash";

/**
 * ## FhiIconTrash
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-trash
 * @element fhi-icon-trash
 */
@customElement(FhiIconTrashSelector)
export class FhiIconTrash extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M18.25 6.75H5.75V20c0 .256.136.575.405.845.27.27.589.405.845.405h10c.256 0 .575-.136.845-.405.27-.27.405-.589.405-.845zM9.25 17v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0m4 0v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0m2-13c0-.256-.136-.575-.405-.845-.27-.27-.589-.405-.845-.405h-4c-.256 0-.575.136-.845.405-.27.27-.405.589-.405.845v1.25h6.5zm1.5 1.25H21a.75.75 0 0 1 0 1.5h-1.25V20c0 .744-.364 1.425-.845 1.905-.48.48-1.161.845-1.905.845H7c-.744 0-1.425-.364-1.905-.845-.48-.48-.845-1.161-.845-1.905V6.75H3a.75.75 0 0 1 0-1.5h4.25V4c0-.744.364-1.425.845-1.905.48-.48 1.161-.845 1.905-.845h4c.744 0 1.425.364 1.905.845.48.48.845 1.161.845 1.905z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
